exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".pufferfish-403{position:relative;top:0;bottom:0;padding-top:20vh;text-align:center;color:rgba(48,48,48,.5);font-size:28px;font-weight:bold}", ""]);
